import { isUndefined } from "lodash";
import { ReactComponent as LeaderIcon } from "../../icons/leader.svg";
import { ILocationEventsResponseBody } from "../../types/response/ILocationEventsResponseBody";
import { calculateDayOnly } from "../../utils/dDayCalculate";
import { getSiteType } from "../../utils/SiteTypes";
import GridSkeletons from "../skeletons/GridSkeletons";

interface LocationPendingEventProps {
  eventsPending: ILocationEventsResponseBody[];
  locationSiteType: string;
  onEventClick: (locationId: string, eventId: string) => void;
  locationId: string;
}

const LocationPendingEvent = ({
  eventsPending,
  locationSiteType,
  onEventClick,
  locationId
}: LocationPendingEventProps) => {
  if (isUndefined(eventsPending)) {
    return <GridSkeletons gridSize={2} skeletonSize={2} skeletonHeight={'209.5px'} paddingTop={'16px'} />
  }

  return (
    <div className="mt-[16px] overflow-x-auto hidden-scroll">
      <div className="flex flex-nowrap mb-[4px] gap-[10px]">
        {eventsPending?.map((event) => {
          const { openDday } = calculateDayOnly(event.startDate, event.endDate);
          return (
            <div
              key={event.eventId}
              className="w-[124px] cursor-pointer flex-shrink-0"
              onMouseDown={() => onEventClick(locationId, event.eventId)}
            >
              <div className="relative">
                <img
                  src={event?.baseImageUrl}
                  alt="event_image"
                  className="rounded-[10px] w-[124px] h-[147px] object-cover"
                />
                <span className="absolute top-0 left-0 content-center items-center justify-center w-fit h-[23px] rounded-tl-[10px] rounded-br-[10px] bg-onLabel-light text-pure-white text-[11px] font-semibold leading-[13px] py-[5px] pl-[9px] pr-[8px]">
                  {`D-${openDday}`}
                </span>
                {/* <img src={alarm_icon} alt="alarm" className="absolute right-3 bottom-3" /> */}
              </div>
              <div className="flex flex-col gap-[6px]">
                <div className="flex flex-row items-center gap-[4px] mt-[8px] text-[13px] text-main-light-3 dark:text-main-dark-3">
                  <img
                    src={`/assets/icons/graphic-3d/${
                      getSiteType(locationSiteType).iconName
                    }.png`}
                    alt="site_type_icon"
                    className="w-[13px] h-[13px] inline-block"
                  />
                  <span>
                    {event.members && event.members.length > 0
                      ? `${event.artist.shortName} ${event.members
                          .map((member) => member.name)
                          .join(', ')}`
                      : event.artist.name}
                  </span>
                </div>

                <div className="text-[16px] leading-[19px] font-semibold text-main-light-2 dark:text-main-dark-2 overflow-hidden [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]">
                  {event?.name}
                </div>

                <div className="flex flex-row text-[13px] font-normal gap-[4px] items-center text-main-light-4 dark:text-main-dark-4">
                  <LeaderIcon className="flex-shrink-0 w-[14px] h-[14px] fill-sub-light-1 dark:fill-sub-dark-1" />
                  <div className="leading-[16px] truncate">{event?.organizerTwitterId}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LocationPendingEvent;
